export default "__VITE_ASSET__DaCFWVgl__"